import {  React } from "react";

function Kontakt () {

    return(

        <section className="flex flex-col items-center py-14 px-6 bg-beige-light ">
            <h2 className="text-3xl md:text-3xl font-serif mb-8">Hitta till oss</h2>
                <div className="mb-8 text-center space-y-1">
                    <p className="font-medium">Centralgatan 17</p>
                    <p>852 32 Sundsvall</p>
                    <p>076-0268462</p>
                    <p className="text-sm text-brown/70"><a href="mailto:info@studioclaire.se">info@studioclaire.se</a></p>
                </div>

                <div className="w-full max-w-xl h-[300px] md:h-[450px] rounded-xl overflow-hidden shadow-md">

                    <iframe title="googlemaps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1849.1404741093127!2d17.303691278151167!3d62.389086276238054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4664675dbac2b1a3%3A0x82f4badc2c20e38!2sCentralgatan%2017%2C%20852%2032%20Sundsvall!5e0!3m2!1ssv!2sse!4v1768907783097!5m2!1ssv!2sse"  loading="lazy" referrerpolicy="no-referrer-when-downgrade" className="w-full h-full  border-0"></iframe>
            
                </div>
                <a
                href="https://maps.google.com/?q=Centralgatan 17 Sundsvall"
                target="_blank"
                rel="noreferrer"
                className="mt-6 text-sm uppercase tracking-widest underline"
                >
                    Öppna i Google Maps
                </a>

        </section>

    )
}

export default Kontakt;